module.exports = __webpack_public_path__ + "img/LY.c7d7d032.png";